module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box"
  }, [_c('a', {
    staticClass: "pull-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showAll()
      }
    }
  }, [_vm._v("Voir toutes les propales")]), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Propales récentes")]), _vm._v(" "), _c('ul', [_vm._l((_vm.relations.estimates), function(estimate) {
    return _c('li', {
      key: estimate.id
    }, [_c('i', {
      class: ['text-' + _vm.getStatus('estimate', estimate).color, 'fa', _vm.getStatus('estimate', estimate).icon]
    }), _vm._v(" " + _vm._s(estimate.number) + "\n      "), (estimate.amount_total_no_vat !== null) ? _c('span', [_vm._v("(" + _vm._s(estimate.amount_total_no_vat) + " € HT)")]) : _vm._e(), _vm._v(" "), _c('source-app', {
      attrs: {
        "name": estimate.source_name,
        "size": "tiny"
      }
    }), _vm._v(" "), (_vm.getStatus('estimate', estimate).text != '') ? _c('div', {
      class: 'text-' + _vm.getStatus('estimate', estimate).color
    }, [_vm._v("\n        " + _vm._s(_vm.getStatus('estimate', estimate).text) + "\n      ")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.relations.contracts), function(contract) {
    return _c('li', {
      key: contract.id
    }, [_c('i', {
      class: ['text-' + _vm.getStatus('contract', contract).color, 'fa', _vm.getStatus('contract', contract).icon]
    }), _vm._v(" Contrat " + _vm._s(contract.number) + "\n      "), _c('source-app', {
      attrs: {
        "name": contract.source_name,
        "size": "tiny"
      }
    }), _vm._v(" "), (_vm.getStatus('contract', contract).text != '') ? _c('div', {
      class: 'text-' + _vm.getStatus('contract', contract).color
    }, [_vm._v("\n        " + _vm._s(_vm.getStatus('contract', contract).text) + "\n      ")]) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-772fda96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerPropositionsSummaryWidget.vue
// module id = 713
// module chunks = 1